import { jsx as _jsx } from "react/jsx-runtime";
import { Card } from "../../card";
import { BlockField } from "../";
export const BlockCard = ({ children, queryVariables, onCatch }) => (_jsx(Card, { children: children.map(block => (_jsx(BlockField, { block: block, queryVariables: queryVariables, onCatch: onCatch }, block.id))) }));
